import RegisterForm from 'components/Forms/RegisterForm/RegisterForm'
import RegisterEmployeeForm from 'components/Forms/RegisterEmployeeForm/RegisterEmployeeForm'

import { Login } from 'pages'

import PersonalCard from 'pages/ProfilePage/PersonalCard/PersonalCard'
import AdminPage from 'pages/AdminPage/AdminPage'
import ReportCard from "pages/ReportCard/ReportCard";
import EmployeeCard from 'pages/EmployeeCard/EmployeeCard'
import AdminPanelPage from 'pages/AdminPanelPage/AdminPanelPage';
import ReportsPage from 'pages/ReportsPage/ReportsPage';
import DocflowPage from 'pages/Docflow/DocflowPage';
import path from 'path-browserify';
import userInfo from 'utils/userInfo';

// Получаем данные пользователя
const getUserRoutes = () => {
  const user = userInfo();
  
  // Базовые маршруты для всех пользователей
  const baseRoutes = [
    { path: '/', component: <Login /> },
    { path: '/register_person/', component: <RegisterForm /> },
    { path: '/register_employee/', component: <RegisterEmployeeForm /> },
    { path: '/employee-card/', component: <EmployeeCard /> },
    { path: '/docflow/', component: <DocflowPage /> },
  ];

  // Маршруты доступные всем авторизованным пользователям (КРОМЕ сотрудников Кыргызкомур)
  const commonRoutes = [
    { path: '/report-card/', component: <ReportCard /> },
    { path: '/personalcard/', component: <PersonalCard /> },
  ];

  // Маршруты ТОЛЬКО для сотрудников Кыргызкомур
  const employeeRoutes = [
    { path: '/personalcard/', component: <PersonalCard /> },
  ];

  // Маршруты для is_report_of
  const reportRoutes = [
    { path: '/reports/', component: <ReportsPage /> },
  ];

  // Маршруты только для is_admin_of
  const adminRoutes = [
    { path: '/adminpanel/', component: <AdminPanelPage /> },
    { path: '/admin_organizations/', component: <AdminPage /> },
  ];

  // Если пользователь админ - все маршруты
  if (user?.is_admin_of) {
    return [...baseRoutes, ...commonRoutes, ...reportRoutes, ...adminRoutes, { path: '/employee-card/', component: <EmployeeCard /> }];
  }
  
  // Если пользователь is_report_of - базовые + общие + отчеты
  if (user?.is_report_of) {
    return [...baseRoutes, ...commonRoutes, ...reportRoutes];
  }

  // Если пользователь является сотрудником Кыргызкомур
  if (user?.is_personal_kyrgyzkomur) {
    return [...baseRoutes, ...employeeRoutes];
  }
  
  // Для всех остальных - только базовые + общие
  return [...baseRoutes, ...commonRoutes];
};

export const routes = getUserRoutes();
